import {Card, Title} from '@yoast/ui-library';
import React from 'react';
import useScan from "../../hooks/useScan";

const NoResultsCard: React.FC = () => {
  const { data: scan, isLoading, isRefetching } = useScan();
  if((isLoading && ! isRefetching) || scan?.mentions?.mentionedInNumberOfQueries?.value !== 0 ){
    return null;
  }

  return (
  <Card className="yst-overflow-visible md:yst-col-span-2 yst-text-slate-800">
    <Card.Content className="yst-space-y-4 yst-max-w-2xl">
      <Title size="3">
        We couldn’t find your brand in this brand analysis...
      </Title>
      <p>This means LLMs may not yet be surfacing your site in answers. Don’t worry, here are some steps you can take today to boost your AI visibility:</p>
      <ol className="yst-list-decimal yst-ml-5 [&>li::marker]:yst-font-semibold ">
        <li>
          <strong>Activate llms.txt →</strong>{' '}
          <a href="https://yoast.com/features/llms-txt/" target="_blank" rel="noopener noreferrer">
            Set up llms.txt in Yoast SEO
          </a>.{' '}
          Make sure AI systems know where to look and which pages matter most.
        </li>
        <li>
          <strong>Adopt an LLM-friendly content structure →</strong>{' '}
          <a href="https://yoast.com/yoast-seo-premium-september-9-2025/" target="_blank" rel="noopener noreferrer">
            See how in our latest update
          </a>.
          Start with clear definitions or TL;DRs, use subheadings, and format answers so LLMs can lift them directly.
        </li>
        <li>
          <strong>Simplify writing and readability →</strong>{' '}
          Use shorter sentences, plain language, and one idea per paragraph. This makes it easier for AI systems to recognize and quote your content.
        </li>
      </ol>
      <p>
        Want to go deeper? →{' '}
        <a href="https://yoast.com/how-to-optimize-content-for-llms/" target="_blank" rel="noopener noreferrer">
          Read our full guide on optimizing content for LLMs
        </a>.
      </p>
    </Card.Content>
  </Card>
)};

export default NoResultsCard;
